import axios from "axios";

const mapRecognition = (item) => ({
    leader: item.Lider ?? "",
    collaborator: item.Colaborador ?? "",
    directLeader: item.JefeDirecto ?? "",
    pilar: item.Pilar ?? "",
    type: item.TipoReconocimiento ?? "",
    message: item.Comentarios ?? "",
    date: item.Fecha ?? "",
    score: item.valor ?? null,
});

export const getRecognitions = async (email, token) => {
    const response = await axios({
        method: "GET",
        baseURL: `${process.env.REACT_APP_PROTOCOL_BACKEND}://${process.env.REACT_APP_HOST_BACKEND}${process.env.REACT_APP_PORT_BACKEND}`,
        url: process.env.REACT_APP_API_RECONOCIMIENTOS_GETRECONOCIMIENTOS,
        params: { strEmailColaborador: email },
        headers: { token },
    });

    const { error, data } = response.data;

    if (error) {
        throw new Error("La API retornó un error al obtener los reconocimientos.");
    }

    return (data ?? []).map(mapRecognition);
};
